import { FC, ReactNode } from 'react'
import styles from "./sidebar.module.scss"

type Props = {
  children: ReactNode
}

export const Sidebar: FC<Props> = ({children}) => {
  return (
    <section className={styles.sidebar}>{children}</section>
  )
}
